/**
 * App configuration — all settings in one place.
 * Change values here without touching code.
 */

export const config = {
  app: {
    name: 'checksandticks',
    title: 'ChecksAndTicks',
  },

  api: {
    baseUrl: import.meta.env.VITE_API_URL || (typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? `${window.location.protocol}//${window.location.hostname}:8084/api/v1`
      : '/api/v1'),
    timeout: 30000,
    retry: {
      maxAttempts: 3,
      baseDelay: 1000,
    },
  },

  auth: {
    storageKey: 'auth_token',
    refreshBuffer: 60_000,
    headerName: 'Authorization',
    tokenPrefix: 'Bearer',
    vault: {
      // PIN unlock: lock the vault (wipe ciphertext) after this many failed attempts.
      maxPinAttempts: 5,
      // Storage keys for vault metadata (ciphertext lives under cnt_vault_enc).
      enrolledKey: 'cnt_vault_enrolled',   // 'prf' | 'pin' | absent
      pinSaltKey: 'cnt_vault_pin_salt',
      pinAttemptsKey: 'cnt_vault_pin_attempts',
      prfCredentialKey: 'cnt_vault_prf_cred', // base64url credential id for PRF get()
    },
  },

  sync: {
    pullInterval: 30_000,
    batchSize: 50,
  },

  network: {
    pingUrl: '/api/v1/health/live',
    pingInterval: 30_000,
  },

  db: {
    name: 'checksandticks',
  },

  push: {
    vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY || '',
    registrationEndpoint: '/api/v1/push/subscriptions',
  },

  notifications: {
    maxCount: 100,
    maxAge: 7 * 24 * 60 * 60 * 1000, // 7 days
  },
} as const;
